import { service } from '@/ajax/request'

// 分页列表
export const getWeigherMetabolismConfigPage = (params: {
  pageNum: number
  pageSize: number
  resultKey1?: string
  resultKey2?: string
}) => {
  return service({
    url: `/weigher-metabolism-config/page`,
    method: 'POST',
    params,
  })
}

// 筛选项
export const getWeigherMetabolismConfigFilterOptions = () => {
  return service({
    url: `/weigher-metabolism-config/filter-options`,
    method: 'POST',
  })
}

// 编辑
export const updateWeigherMetabolismConfig = (params: {
  id: number
  symptoms: string
  reasons: string
  preventDiseases: string
}) => {
  return service({
    url: `/weigher-metabolism-config/update`,
    method: 'POST',
    params,
  })
}
